import React from "react"
import { useNavigate } from "react-router"
import ContainerBackgroundWrapper from "../components/Backgrounds"
import styled from "styled-components"
import Text from "../styledComponents/TextStyled"
import Button from "../components/atoms/Buttons"

const ContenidoIdle = styled.div`
  height: calc(100vh - 2rem);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 900;
  gap:32px;
`

const IdleHasWinner = () => {
  const navigate = useNavigate()

  return (
    <ContainerBackgroundWrapper>
      <ContenidoIdle>
        <Text textStyle='large'>¡El sorteo seleccionado ya tiene un ganador registrado!</Text>
        <Button onClick={() => navigate('/sorteo-list')}>
          Inicio
        </Button>
      </ContenidoIdle>
    </ContainerBackgroundWrapper>
  )
}

export default IdleHasWinner;
